import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MailCheck, MailX } from "lucide-react";
import api, { apiError } from "@/lib/api";

export default function ConfirmEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("checking"); // checking | success | error
  const [message, setMessage] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setState("error");
      setMessage("This confirmation link is missing or malformed.");
      return;
    }
    api.post("/auth/confirm-email", { token })
      .then((r) => { setState("success"); setMessage(r.data.new_email); })
      .catch((e) => { setState("error"); setMessage(apiError(e)); });
  }, [token]);

  return (
    <div className="silk-hero min-h-[70vh] flex items-center justify-center px-5 py-20">
      <div className="w-full max-w-md silk-card rounded-lg p-8 sm:p-10 text-center">
        {state === "checking" && (
          <p className="text-sm text-muted-foreground" data-testid="confirm-email-checking">Confirming your new email…</p>
        )}
        {state === "success" && (
          <div data-testid="confirm-email-success">
            <div className="w-14 h-14 mx-auto rounded-full border-2 border-primary text-primary flex items-center justify-center mb-5">
              <MailCheck size={24} />
            </div>
            <h1 className="font-display text-4xl text-foreground mb-4">Email updated</h1>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Your account email is now <span className="text-foreground">{message}</span>. Use it next time you sign in.
            </p>
            <p className="text-sm text-muted-foreground mt-6">
              <Link to="/" className="cream-link" data-testid="confirm-email-home-link">Back to O.R.E.C</Link>
            </p>
          </div>
        )}
        {state === "error" && (
          <div data-testid="confirm-email-error">
            <div className="w-14 h-14 mx-auto rounded-full border-2 border-destructive text-destructive flex items-center justify-center mb-5">
              <MailX size={24} />
            </div>
            <h1 className="font-display text-4xl text-foreground mb-4">Couldn't confirm</h1>
            <p className="text-sm text-muted-foreground leading-relaxed">{message}</p>
            <p className="text-sm text-muted-foreground mt-6">
              <Link to="/ripples" className="cream-link" data-testid="confirm-email-retry-link">Request the change again</Link>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
